"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyQuery = exports.removeQueryParams = exports.parseQuery = exports.appendQueryParams = void 0;
var _urlParse = _interopRequireDefault(require("url-parse"));
var _qs = require("qs");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Bind option to ignore '?' at the beginning of query string
var parseQuery = exports.parseQuery = function parseQuery(query) {
  return (0, _qs.parse)(query, {
    ignoreQueryPrefix: true
  });
};

// Bind options to not encode special symbols when stringifying and to use empty brackets format
var stringifyQuery = exports.stringifyQuery = function stringifyQuery(query) {
  return (0, _qs.stringify)(query, {
    arrayFormat: 'brackets'
  });
};

/**
 * @param {string} url
 * @param {string[]} params
 * @param {boolean} isRelative
 * @returns {string}
 */
var appendQueryParams = exports.appendQueryParams = function appendQueryParams(url, params) {
  var isRelative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var parsedUrl = new _urlParse["default"](url, isRelative ? ' ' : '', parseQuery);
  parsedUrl.query = parsedUrl.query || {};
  Object.keys(params).forEach(function (paramName) {
    if (params[paramName]) {
      parsedUrl.query[paramName] = params[paramName];
    }
  });
  return parsedUrl.toString(stringifyQuery);
};

/**
 * @param {string} url
 * @param {string[]} params
 * @param {boolean} isRelative
 * @returns {string}
 */
var removeQueryParams = exports.removeQueryParams = function removeQueryParams(url, params) {
  var isRelative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // Note: An invalid location to prevent protocol + location adding to a relative link
  var parsedUrl = new _urlParse["default"](url, isRelative ? ' ' : '', parseQuery);
  parsedUrl.query = (0, _omit2["default"])(parsedUrl.query, params);
  return parsedUrl.toString(stringifyQuery);
};